module.exports = __webpack_public_path__ + "img/321794e98b986fd0fa559d6060dae592.png";